import { render } from "./wave_animation.vue?vue&type=template&id=26004491"
import script from "./wave_animation.vue?vue&type=script&lang=js"
export * from "./wave_animation.vue?vue&type=script&lang=js"

import "./wave_animation.vue?vue&type=style&index=0&id=26004491&lang=css"
script.render = render

export default script